module.exports = __webpack_public_path__ + "static/media/redCloseIcon.e76798a6.svg";